import Vue from "vue";
import FaqDB from "./FaqDB.json";

export default {
  name: "FrequentlyAskedQuestions",
  data: function() {
    return {
      faqJSON: FaqDB,
      faqQuestions: []
    };
  },

  mounted() {
    this.faqJSON = FaqDB;
    this.changeJson(1);
  },

  methods: {
    changeJson(jsonNumber) {
      if (this.faqJSON != null) {
        this.faqJSON.forEach(element => {
          if (element.id == jsonNumber) {
            this.faqQuestions = element.questions;
          }
          console.log(this.faqQuestions);
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/faq/mixins/FrequentlyAskedQuestions.js